import React, { Component } from 'react';
import { redirectTo } from '../../../actionSMB/redirection';
import { connect } from 'react-redux'
import { Pages } from '../../../constantsSMB/actionType';
import { Utils } from '../../../utilSMB/utils'
import * as productDetailsAction from '../../../actionSMB/productDetailsAction'
import * as productsAction from '../../../actionSMB/productsAction'
import * as accessoriesAction from '../../../actionSMB/accessoriesAction';
import { updateSCTags } from './../../../serviceSMB/dtmTag';
import { catchJSException } from './../../../serviceSMB/logService';
import { withCookies } from 'react-cookie';


class Cart extends Component {
    constructor(props) {
        super(props)
        this.ulRef = React.createRef()
        this.state = {
            cartTotal: 0,
            heightAdded: 0,
            stopScroll: false
        }
    }

    editCartHandler = (productName) => {
        try {

            let scTagData = "edit: ".concat(productName);
            updateSCTags(scTagData);
            let redirectURL = Pages.ShoppingCart;
            redirectTo(redirectURL, this.props.props.dispatch);
            // this.props.pushHistory.push(redirectURL)
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'editCartHandler', ex);
        }
    }
    OnCheckoutClick = (() => {
        try {
            updateSCTags("checkout");
            let redirectURL = "";
            const { cookies } = this.props;
            let userInfo = cookies.get('userinfo');
            if (this.props.categoriesState.isValidUser && !this.props.categoriesState.isGuestFlow){
               if(userInfo !== undefined && userInfo !== "" && userInfo !== null) {
                redirectURL = Pages.sCheckOut;
                //getDTMInit("checkoutShipping");
                }else{
                    Utils.clearRedux("checkout"); /** Clearing checkout redux if auto sign out happens and redirecting to begin checkout page. */
                    accessoriesAction.updateProfileCall(false,this.props.dispatch);
                    redirectURL = Pages.BeginCheckout;
                }
            }else {
                redirectURL = Pages.BeginCheckout;
                //getDTMInit("beginCheckout");
            }
            redirectTo(redirectURL, this.props.dispatch);
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'OnCheckoutClick', ex);
        }
    })
    OnViewcartClick = (() => {
        try {
            updateSCTags("view cart");
            //getDTMInit("viewCart", "", "", true);
            let redirectURL = Pages.ShoppingCart;
            redirectTo(redirectURL, this.props.dispatch);
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'OnViewcartClick', ex);
        }
    })

    componentDidMount() {
        if (this.props.cartProductDetail && this.props.cartProductDetail.cartProduct) {
            this.setState({
                ...this.state,
                cartTotal: this.props.cartProductDetail.cartProduct.length,
            })
        }
    }
    nextThreeItems = () => {
        try {

            let x = 89;
            if (this.state.cartTotal >= 3) {
                this.setState({
                    ...this.state,
                    heightAdded: this.state.heightAdded + (x * 3),
                    cartTotal: this.state.cartTotal - 3,
                    stopScroll: true
                },
                    () => {
                        this.ulRef.current.scroll({
                            top: this.state.heightAdded,
                            behavior: 'smooth'
                        });

                    })
            }
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'nextThreeItems', ex);
        }


    }

    previousThreeItems = () => {
        try {

            if (this.state.stopScroll) {
                this.setState({
                    ...this.state,
                    cartTotal: this.state.cartTotal + 3,
                    heightAdded: this.state.heightAdded - (89 * 3),
                }, () => {
                    this.ulRef.current.scroll({
                        top: this.state.heightAdded,
                        behavior: 'smooth'
                    });
                    if (this.state.heightAdded === 0) {
                        this.setState({
                            ...this.state,
                            stopScroll: false
                        })
                    }
                })
            }
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'previousThreeItems', ex);
        }
    }

    handleClick = ((selectedprds, selectedCategoryId, selectedprdId, skuId) => {
        try {
            let selectedPrd = Utils.removeSpecialChars(selectedprds)
            // let selectedCategoryName = this.props.categoriesState.categoriesExp.find(obj => obj.categoryId === selectedCategoryId).name
            // selectedCategoryName = Utils.removeSpecialChars(selectedCategoryName)
            let request = {
                "categoryId": selectedCategoryId,
                "productId": selectedprdId,
                "skuId":skuId
            }
            // let redirectURL = Pages.Category + selectedCategoryName + '/' + selectedPrd
            var rqstInfo = {
                "productName": selectedprds
            }
            let request1 = JSON.stringify(rqstInfo);
            productsAction.getPageinfoByName(request1, this.props.dispatch)
            let redirectURL = Pages.Category + selectedPrd + "/";
            productDetailsAction.storeProductId(this.props.dispatch, request)
            redirectTo(redirectURL, this.props.dispatch)

        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'handleClick', ex);
        }
    })

    render() {
        let domain = Utils.getDomainUrl();
        let cartProductcount = 0;
        let productCount = 0;
        let cartProductDetails
        let redirectURL = "";
        const { cookies } = this.props;
        let userInfo = cookies.get('userinfo');
        if (this.props.categoriesState.isValidUser && !this.props.categoriesState.isGuestFlow){
            if(userInfo !== undefined && userInfo !== "" && userInfo !== null) {
            redirectURL = Pages.sCheckOut;
            //getDTMInit("checkoutShipping");
            }else{
            redirectURL = Pages.BeginCheckout;
            }
        }else {
            redirectURL = Pages.BeginCheckout;
            //getDTMInit("beginCheckout");
        }
        if (this.props.cartProductDetail && this.props.cartProductDetail.cartProduct) {
            productCount = this.props.cartProductDetail.cartProduct.length;
            for (var i = 0; i < this.props.cartProductDetail.cartProduct.length; i++) {
                cartProductcount = parseInt(cartProductcount) + parseInt(this.props.cartProductDetail.cartProduct[i].qty)
            }
            cartProductDetails = this.props.cartProductDetail.cartProduct.map(cartProductDetails => {
                let discount = '';
                let discountprice = '';
                if (cartProductDetails.discount && cartProductDetails.discount !== "0.00") {
                    discount = (
                        <li className="cart-box_sale text-left">
                            <span className="sale_text">Sale ${cartProductDetails.discount} Off</span>
                        </li>

                    )
                }
                if (cartProductDetails.discount && cartProductDetails.discount !== "0.00") {
                    discountprice = (
                        <div>
                            <div className="order-summary-label">
                                <div className="order-summary_price-label">
                                    Price:
                        </div>
                                {/* {cartProductDetails.discount !== "0.00"  && <div>
                            Was <strike>${cartProductDetails.price} </strike> </div>} */}
                        Was <strike>${cartProductDetails.price}</strike>
                                <div className="order-summary_retail-price">
                                    <div className="order-summary_retail-price normal">$ {cartProductDetails.discountPrice}/each</div>
                                </div>
                            </div>

                        </div>
                    )
                }
                else {
                    discountprice = (
                        <div>
                            <div className="order-summary-label">
                                <div className="order-summary_price-label">
                                    Price:
                        </div>
                                <div className="order-summary_retail-price">
                                    <div className="order-summary_retail-price">$ {cartProductDetails.price}/each</div>
                                </div>
                            </div>

                        </div>
                    )
                }
                return (

                    <li key={cartProductDetails.itemId}>
                        <div className="cart-box_block">
                            <img src={Utils.getImagePath(cartProductDetails.imgpath)} alt="" /></div>
                        <div className="cart-box_product-name p-50 cart-box_product-name-desktop">
                            <ul>
                                <li className="cart-box_name">

                                    <a href={Pages.Category + Utils.removeSpecialChars(cartProductDetails.seoKW) + "/"} className="disp_prod_link" onClick={(e) => {
                                        e.preventDefault();
                                        this.handleClick(cartProductDetails.seoKW, cartProductDetails.categoryId, cartProductDetails.pppId,cartProductDetails.skuId)
                                    }}>
                                        {cartProductDetails.itemName}</a>
                                </li>
                                <li className="cart-box_quantity">Quantity: {cartProductDetails.qty} </li>
                                {discount}
                            </ul>
                        </div>

                        <div className="cart-box_product-price">
                            <div className="cart-box_price">
                                {discountprice}
                            </div>
                            <div className="cart-box_product-Edit">
                                <a href={Pages.ShoppingCart} onClick={(e) => { e.preventDefault(); this.editCartHandler(cartProductDetails.name) }} >Edit</a>
                            </div>
                        </div>

                    </li>
                )
            })
        };

        let cartData = "";
        if (cartProductcount === 0) {
            cartData = (
                <div className="cart-box_empty" aria-hidden="true" tabIndex="-1">

                    <p className="apex-book text-large text-grey-2">There are no items in your cart.</p>
                    <div className="cart-box_notify" aria-hidden="true" tabIndex="-1">
                        <div className="cart-box_icon" aria-hidden="true" tabIndex="-1">
                            <span className="vzicon icon-delivery text-grey-2"></span>
                        </div>
                        <div className="cart-box_shipping" aria-hidden="true" tabIndex="-1">
                            <p className="margin-bottom-zero"><em>You’ll choose your shipping at checkout.</em></p>
                        </div>
                    </div>
                </div>
            )
        }
        else if (cartProductcount > 0) {
            cartData = (
                <div className="cart-box_product   m_cart-box_product">
                    <div className="cart-box_product-title">My cart</div>
                    <ul ref={this.ulRef} className="cart-box_product-lists" id="m_cart_box">
                        {cartProductDetails}
                    </ul>
                    <div className="flyoutCartCount" style={{ display: 'none' }}><span className="toolbar_count">2</span></div>
                    <div className="cart-box_placeholder">
                        <div className="cart-box_total"><span className="cart-box_sub-total">Subtotal:</span><span className="right">
                            $ {this.props.cartProductDetail.subTotal}
                        </span></div>
                        {productCount >= 4 &&
                            <div>
                                <div className="cart-box_next-list ">
                                    <a tabIndex="0" onClick={this.previousThreeItems} className="last_lists">Last 3 items</a>
                                    <span className="padding-vert-tiny text-grey-4-active">|</span>
                                </div>
                                <div className="cart-box_next-list next_lists">
                                    <a tabIndex="0" onClick={this.nextThreeItems}>Next 3 items</a>
                                </div>
                            </div>}
                        <div className="clear right margin-top-small">
                            <a  href={Pages.ShoppingCart} lid="view cart" onClick={(e) => {e.preventDefault();  this.OnViewcartClick() }} className="button secondary cart-box_view-cart">View cart ({cartProductcount})</a>
                            <a href={redirectURL} lid="checkout" onClick={(e) => {e.preventDefault();  this.OnCheckoutClick() }} className="button">Checkout</a>

                        </div>
                    </div>

                </div>
            )
        }
        return (
            <React.Fragment>
                {cartData}
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        categoriesState: state.categoriesSMB,
        productstate: state.productsSMB,
        cartState: state.cartProductDataSMB
    }
}

export default withCookies(connect(
    mapStateToProps
)(Cart));

